import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterLink } from "@angular/router";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-footer",
  standalone: true,
  imports: [CommonModule, RouterLink],
  template: `
    <footer class="bg-gray-900 text-white">
      <!-- Partner Section -->
      <div class="border-b border-gray-800">
        <div class="container mx-auto px-4 py-8">
          <h3
            class="text-center text-gray-400 text-sm font-semibold mb-6 uppercase tracking-wider"
          >
            Unsere Marken & Partner
          </h3>
          <div
            class="flex flex-wrap justify-center items-center gap-8 md:gap-12"
          >
            <a
              href="https://www.fotobox-leipzig.de"
              target="_blank"
              rel="noopener noreferrer"
              class="opacity-70 hover:opacity-100 transition-opacity duration-300"
            >
              <img
                src="assets/logo_fotobox_leipzig.svg"
                alt="Fotobox Leipzig"
                class="h-12 md:h-16 w-auto"
                width="64"
                height="64"
              />
            </a>
            <a
              href="https://www.comic-bot.de"
              target="_blank"
              rel="noopener noreferrer"
              class="opacity-70 hover:opacity-100 transition-opacity duration-300"
            >
              <img
                src="assets/Logo_ComicBot.svg"
                alt="Comic Bot"
                class="h-12 md:h-16 w-auto"
                width="64"
                height="64"
              />
            </a>
            <a
              href="https://www.livemosaik.de"
              target="_blank"
              rel="noopener noreferrer"
              class="opacity-70 hover:opacity-100 transition-opacity duration-300"
            >
              <img
                src="assets/Logo_LiveMosaik.svg"
                alt="Live Mosaik"
                class="h-12 md:h-16 w-auto"
                width="64"
                height="64"
              />
            </a>
            <a
              href="https://www.outdoor-fotobox.de"
              target="_blank"
              rel="noopener noreferrer"
              class="opacity-70 hover:opacity-100 transition-opacity duration-300"
            >
              <img
                src="assets/outdoor-fotobox-logo.svg"
                alt="Outdoor Fotobox"
                class="h-12 md:h-16 w-auto"
                width="64"
                height="64"
              />
            </a>
            <a
              href="https://ai-photo-experience.de"
              target="_blank"
              rel="noopener noreferrer"
              class="opacity-70 hover:opacity-100 transition-opacity duration-300"
            >
              <img
                src="assets/Logo_Ai-Photo-expierience.svg"
                alt="Live Mosaik"
                class="h-12 md:h-16 w-auto"
                width="64"
                height="64"
              />
            </a>
          </div>
        </div>
      </div>

      <div class="container mx-auto px-4 py-12">
        <div class="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 class="font-bold text-lg mb-4">Videowand Leipzig</h3>
            <p class="text-gray-400 text-sm">
              Mobile Videolösungen für Outdoor-Events und Veranstaltungen
            </p>
          </div>
          <div>
            <h4 class="font-bold mb-4">Spezifikationen</h4>
            <ul class="text-sm text-gray-400 space-y-2">
              <li>Größe: 2,5m x 1,5m</li>
              <li>Pixel Pitch: 2,6mm</li>
              <li>Rollenbasis inklusive</li>
              <li>Barrierefreier Zugang erforderlich</li>
            </ul>
          </div>
          <div>
            <h4 class="font-bold mb-4">Kontakt</h4>
            <ul class="text-sm text-gray-400 space-y-2">
              <li>📧 info@videowand-leipzig.de</li>
              <li>📞 +49 (34298) 158673</li>
              <li>📍 Taucha bei Leipzig, Deutschland</li>
            </ul>
          </div>
          <div>
            <h4 class="font-bold mb-4">Rechtliches</h4>
            <ul class="text-sm space-y-2">
              <li>
                <a
                  routerLink="/kontakt"
                  class="text-white hover:text-gray-300 transition"
                  >Kontakt</a
                >
              </li>
              <li>
                <a
                  routerLink="/impressum"
                  class="text-white hover:text-gray-300 transition"
                  >Impressum</a
                >
              </li>
              <li>
                <a
                  [href]="apiUrl + '/datenschutz.pdf'"
                  target="_blank"
                  class="text-white hover:text-gray-300 transition flex items-center gap-1"
                >
                  Datenschutz
                </a>
              </li>
              <li>
                <a
                  [href]="apiUrl + '/agb.pdf'"
                  target="_blank"
                  class="text-white hover:text-gray-300 transition flex items-center gap-1"
                >
                  AGB
                </a>
              </li>
            </ul>
          </div>
        </div>
        <hr class="border-gray-700 mb-6" />
        <div class="text-center text-gray-500 text-sm">
          &copy; 2026 Videowand Leipzig. Alle Rechte vorbehalten.
        </div>
      </div>
    </footer>
  `,
  styles: [],
})
export class FooterComponent {
  apiUrl = environment.apiUrl;
}
